<template>
  <div class="container mx-auto py-8">
    <h1 class="text-2xl font-semibold mb-6">Jadwal Pelaksanaan</h1>
    <table class="min-w-full bg-white">
      <thead class="bg-purple-600 text-white">
        <tr>
          <th class="w-1/6 py-4 px-4">Nama Jadwal</th>
          <th class="w-1/6 py-4 px-4">Waktu Mulai</th>
          <th class="w-1/6 py-4 px-4">Waktu Selesai</th>
          <th class="w-1/6 py-4 px-4">Tempat</th>
          <th class="w-1/6 py-4 px-4">Keterangan</th>
          <th class="w-1/6 py-4 px-4">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(jadwal, index) in jadwalList" :key="jadwal.id" class="text-center border-b border-gray-200">
          <td class="py-4 px-4">{{ jadwal.nama_jadwal }}</td>
          <td class="py-4 px-4">
            <Calendar v-model="jadwal.waktu_mulai" :show-icon="true" readonlyInput />
            <div v-if="errors[`${jadwal.kode_jadwal}`] && errors[`${jadwal.kode_jadwal}`]['waktu_mulai']" class="text-red-500 text-sm">
              {{ errors[`${jadwal.kode_jadwal}`]['waktu_mulai'].join(', ') }}
            </div>
          </td>
          <td class="py-4 px-4">
            <Calendar v-model="jadwal.waktu_selesai" :show-icon="true" readonlyInput />
            <div v-if="errors[`${jadwal.kode_jadwal}`] && errors[`${jadwal.kode_jadwal}`]['waktu_selesai']" class="text-red-500 text-sm">
              {{ errors[`${jadwal.kode_jadwal}`]['waktu_selesai'].join(', ') }}
            </div>
          </td>
          <td class="py-4 px-4">
            <InputText v-model="jadwal.tempat" readonlyInput />
            <div v-if="errors[`${jadwal.kode_jadwal}`] && errors[`${jadwal.kode_jadwal}`]['tempat']" class="text-red-500 text-sm">
              {{ errors[`${jadwal.kode_jadwal}`]['tempat'].join(', ')}}
            </div>
          </td>
          <td class="py-4 px-4">
            <InputText v-model="jadwal.keterangan" readonlyInput />
            <div v-if="errors[`${jadwal.kode_jadwal}`] && errors[`${jadwal.kode_jadwal}`]['keterangan']" class="text-red-500 text-sm">
              {{ errors[`${jadwal.kode_jadwal}`]['keterangan'].join(', ')}}
            </div>
          </td>
          <td class="py-4 px-4">
            <button @click="updateJadwal(jadwal)" class="bg-purple-500 text-white px-4 py-2 rounded">
              Update
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>


<script>
import { defineProps, ref, defineEmits } from 'vue';
import AppLayout from '@/Layouts/AppLayout';
import Calendar from 'primevue/calendar';
import { Inertia } from '@inertiajs/inertia';
import InputText from 'primevue/inputtext';

export default {
  name: "IsianJadwal",
  layout: AppLayout,
  components: {
    AppLayout,
    Calendar,
    InputText
  },
  props: {
    jadwalList: Array,
  },
  data() {
    return {
      errors: {},
    }
  },
  emits: ['update'],
  mounted() {
            this.$toast.add({
                severity: "success",
                summary: "Sukses",
                detail: "Jadwal  berhasil diupdate",
                life: 10500,
            });
  },
  methods: {
    updateJadwal(jadwal) {
      axios.post(route('dokumen_pengadaan.isi_each_jadwal_action', jadwal))
        .then(response => {
          console.warn('response', response);
          if (response.data.success) {
            this.$toast.add({
                severity: "success",
                summary: "Sukses",
                detail: "Jadwal " + jadwal.nama_jadwal +" berhasil diupdate",
                life: 10500,
            });
          } else {
            // alert(response.data.message);
            this.errors = {
              ...this.errors,
              [jadwal.kode_jadwal]: JSON.parse(response.data.message),
            };
            console.log(this.errors);
          }
        })
        .catch(error => {
          this.errors = {
            ...this.errors,
            [jadwal.kode_jadwal]: error.response.data.message,
          };
        });
    }
  }
}
</script>


<style>
  table {
    border-collapse: separate;
    border-spacing: 0 15px;
  }

  th, td {
    padding: 12px 15px;
  }
</style>
